/* eslint-disable no-invalid-this, func-names */
import * as yup from "yup";

declare module "yup" {
  interface StringSchema {
    requireOneOfFields(fields: string[], errorMsg: string): StringSchema;
    requireSibling(field: string, errorMsg?: string): StringSchema;
    validPhoneNumber(errorMsg?: string): StringSchema;
    validSSN(errorMsg?: string): StringSchema;
    validPassword(errorMsg?: string): StringSchema;
  }
  interface DateSchema {
    requireOneOfFields(fields: string[], errorMsg: string): DateSchema;
  }
  interface BooleanSchema {
    requireOneOfFields(fields: string[], errorMsg: string): BooleanSchema;
    toggleSibling(field: string, errorMsg?: string): BooleanSchema;
  }
}

// setup default messages for commonly used validations
yup.setLocale({
  mixed: {
    default: "It is not valid",
    required: "Required field",
  },
  string: {
    email: "Valid email required",
    min: "Must be at least ${min} characters",
    max: "Must be at most ${max} characters",
  },
  number: {
    min: "Must be at least ${min} or greater",
  },
});

yup.addMethod(yup.mixed, "requireOneOfFields", function (fields: string[], msg) {
  return this.test("one-field-required", msg, function () {
    return fields.map((fieldName) => !!this.parent[fieldName]).indexOf(true) >= 0;
  });
});

yup.addMethod(yup.mixed, "requireSibling", function (sibName, msg = "Required field") {
  return this.test("sibling-required", msg, function (value) {
    if (this.parent[sibName]) {
      return !!value;
    }
    return true;
  });
});

yup.addMethod(yup.string, "validPhoneNumber", function (msg = "Invalid phone") {
  return this.test("valid-us-phone", msg, (value) => {
    if (value) {
      return (value || "").replace(/[^0-9]/g, "").length === 10;
    }
    return true;
  });
});

yup.addMethod(yup.string, "validSSN", function (msg = "Invalid SSN") {
  return this.test("valid-ssn", msg, (value) => {
    if (value) {
      return (value || "").replace(/[^0-9]/g, "").length === 9;
    }
    return true;
  });
});

yup.addMethod(yup.mixed, "toggleSibling", function (sibName, msg = "Cannot select both") {
  return this.test("toggle-sibling", msg, function (value) {
    return !(this.parent[sibName] && value);
  });
});

const passMsg =
  "Password must contain one lower case letter, one uppercase letter," +
  " one number, and a minimum of 8 characters total";

yup.addMethod(yup.string, "validPassword", function (msg = passMsg) {
  return this.test("valid-password", msg, (value) => {
    if (value) {
      return (value.length >= 8 && value.match(/[0-9]/) &&
        value.match(/[a-z]/) && value.match(/[A-Z]/)) as boolean;
    }
    return true;
  });
});
